const handleFocus = (e) => {
    const target = e.target;
    target.parentNode.closest(".js_form_item").classList.add('active');
    if(target.hasAttribute('data-placeholder')) {
        target.setAttribute('placeholder', target.getAttribute('data-placeholder'));
    }
};
const handleBlur = (e) => {
    const target = e.target;
    if (!target.value) {
        target.parentNode.closest(".js_form_item").classList.remove('active');
    }
    else{
        target.parentNode.closest(".js_form_item").classList.add('active');
    }
    target.removeAttribute('placeholder');
};
const placeholderFlush = (e) => {
    e.removeAttribute('placeholder');
    if (e.value) {
        e.parentNode.closest(".js_form_item").classList.add('active');
    }
};
const bindEvents = (element) => {
    const floatField = element.querySelector(".c-form__input");
    floatField.addEventListener('focus', handleFocus);
    floatField.addEventListener('blur', handleBlur);
    placeholderFlush(floatField);
};
const init = () => {
    const floatContainers = document.querySelectorAll('.js_form_item');
    for(let i = 0; i < floatContainers.length; i++){
        if(floatContainers[i].querySelector(".c-form__input")){
            bindEvents(floatContainers[i]);
        }
    }
};
const desktop = () => {
    const floatContainers = document.querySelectorAll(".js_form_item");
    for(let i = 0; i < floatContainers.length; i++){
        //console.log("Nalezen form input")
        if(floatContainers[i].classList.contains("js_form_item_narrow")){
            //console.log("Má narrow class!")
            if(floatContainers[i].querySelector(".c-form__input")){
                bindEvents(floatContainers[i]);
                //console.log("Tak jsem nabindoval event");

            }
        }
        else
        {
            //console.log("upravím ho pro desktop");

            if(floatContainers[i].querySelector(".c-form__input")){
                floatContainers[i].querySelector(".c-form__input").removeEventListener("focus", handleFocus);
                floatContainers[i].querySelector(".c-form__input").removeEventListener("blur", handleBlur);
                if(floatContainers[i].querySelector(".c-form__input").hasAttribute('data-placeholder')) {
                    floatContainers[i].querySelector(".c-form__input").setAttribute("placeholder", floatContainers[i].querySelector(".c-form__input").getAttribute('data-placeholder'));
                }
            }
        }

    }
};
export {
    init,
    desktop
};